// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/crypto/decaf377_fmd/v1/decaf377_fmd.proto (package penumbra.crypto.decaf377_fmd.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * A clue for use with Fuzzy Message Detection.
 *
 * @generated from message penumbra.crypto.decaf377_fmd.v1.Clue
 */
export class Clue extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.crypto.decaf377_fmd.v1.Clue";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new Clue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Clue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Clue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Clue, a, b);
    }
}
